/*
 * サブシステム名：
 * 定型コース登録(package版)
 * 表示項目カスタマイズ(幸栄トランスポート)
 */
import D2MSTD0460 from '@/views/MST/D2MSTD0460.js'
// import filter from '@/rahmen/utils/filters'

export default {
  extends: D2MSTD0460,
  name: 'MstTeikeiCorceEditCustomForKet',
  data: () => ({
  }),
  computed: {
  },
  methods: {
  }
}
